import { Modal, ModalBody, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Form, Formik, FormikErrors } from 'formik';
import { noop } from 'lodash';
import { useEffect } from 'react';
import { Button } from 'ui-components/dist/Button';
import { Input } from 'ui-components/dist/Input';
import { EmailFormValue } from '~/components/SharePageModal/ShareModal.models';
import { trackEvent } from '~/core/utils/trackEvent';
import { isValidEmail } from '~/utils';

import { EmailAccessScreenHeader } from './EmailAccessScreenHeader';

export interface IEmailAccessScreenProps {
  agencyName: string;
  agencyLogo: string;
  isOpen: boolean;
  listName: string;
  managerName: string;
  onSubmit: (email: string) => void;
}

const validate = ({ email }: EmailFormValue) => {
  const errors: FormikErrors<EmailFormValue> = {};

  if (!isValidEmail(email)) {
    errors.email = 'Must be a valid email';
  }

  return errors;
};

export const EmailAccessScreen: React.FC<IEmailAccessScreenProps> = ({
  agencyName,
  agencyLogo,
  isOpen,
  listName,
  managerName,
  onSubmit,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    trackEvent('foam-shared-link-require-email', {
      name: listName,
      agency: agencyName,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <Modal size="lg" isOpen={isOpen} onClose={noop} isCentered>
      <ModalOverlay
        sx={{
          backdropFilter: 'blur(6px)',
        }}
      />
      <ModalContent>
        <ModalBody paddingY={8} paddingX={6}>
          <EmailAccessScreenHeader
            name={listName}
            agencyName={agencyName}
            agencyLogo={agencyLogo}
          />
          <Formik
            enableReinitialize
            initialValues={{
              email: '',
            }}
            onSubmit={({ email }) => onSubmit(email)}
            validate={validate}
          >
            {({ isSubmitting, values }) => (
              <Form>
                <Input
                  id="email"
                  isFullWidth
                  type="email"
                  name="email"
                  withClearButton={false}
                  info={`Enter your email to view. Your information will only be
                      shared with ${managerName}`}
                />

                <Button
                  variant="primary"
                  isDisabled={isSubmitting || !isValidEmail(values.email)}
                  type="submit"
                  sx={{
                    width: 'full',
                    marginTop: 6,
                  }}
                >
                  Continue
                </Button>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
